import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_MEMBER_ENDPOINT } from '@/services/org-admin';
import type { AssignMemberRoleInput, OrgMemberResponse } from '@/services/org-admin';

export function useAssignMemberRole() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: async ({ memberId, input }: { memberId: string; input: AssignMemberRoleInput }) => {
      const { data } = await axiosInstance.patch<OrgMemberResponse>(ORG_MEMBER_ENDPOINT(orgId!, memberId), input);
      return data.member;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['org-members', orgId] });
    },
    // Caller already shows its own success/error toast — suppress the global one.
    meta: { silent: true },
  });
}
